import { Box } from '@mui/material'
import { ArrowDown, ArrowSwapVertical, ArrowUp } from 'iconsax-react'
import React from 'react'

interface CommonSortComponentProps {
  sortConfig?: { key: string; direction: 'none' | 'reset' | 'asc' | 'desc' | string } | null | undefined
  title: string
  configKey: string
}

const CommonSortComponent = ({ sortConfig, title, configKey }: CommonSortComponentProps) => {
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
        <span>{title}</span>
        {configKey ? (
          sortConfig?.key === configKey ? (
            sortConfig.direction === 'asc' ? (
              <ArrowUp size='18' color='#41a129' className='' />
            ) : sortConfig.direction === 'reset' || sortConfig.direction === 'none' ? (
              <ArrowSwapVertical size='18' color='#000' />
            ) : (
              <ArrowDown size='18' color='#e84e6a' className='' />
            )
          ) : (
            <ArrowSwapVertical size='18' color='#000' />
          )
        ) : null}
      </Box>
    </React.Fragment>
  )
}

export default CommonSortComponent
